import {
FaCopy,
FaShareAlt
} from "react-icons/fa";

export default function ReferralActions({
referralCode,
copied,
copyText,
shareLink,
handleShare
}){

return(

<section className="mt-5 rounded-[2rem] border border-white/10 bg-[#10182A]/90 p-5 shadow-xl">

<h2 className="text-xl font-black text-white">
کد دعوت تو
</h2>

<div className="mt-4 rounded-2xl bg-white/5 border border-white/10 p-4 flex items-center justify-between">

<div className="text-2xl font-black tracking-widest text-purple-300">
{referralCode}
</div>

<button
onClick={()=>copyText(
referralCode,
"code"
)}
className="px-4 py-2 rounded-xl bg-purple-600 text-white text-sm font-bold flex items-center gap-2"
>

<FaCopy/>

{
copied==="code"
?
"کپی شد"
:
"کپی کد"
}

</button>

</div>

<div className="grid sm:grid-cols-2 gap-3 mt-4">

<button
onClick={()=>copyText(
shareLink,
"link"
)}
className="w-full py-3 rounded-2xl bg-white/5 border border-white/10 font-bold"
>

{
copied==="link"
?
"لینک کپی شد"
:
"کپی لینک دعوت"
}

</button>

<button
onClick={handleShare}
className="w-full py-3 rounded-2xl bg-gradient-to-l from-purple-600 to-blue-500 font-bold text-white flex justify-center items-center gap-2"
>

<FaShareAlt/>

اشتراک سریع

</button>

</div>

</section>

)

}